<template>
<div class="container-fluid">


    <!-- Modal CONFIRM -->
    <modalConfirm ref="confirmModal" />

     <!-- Modal MESSAGE -->  
    <modalMessage ref="msgModal"/> 

    
<div v-if="delivery">
  
    <div v-if="showDocuments" class="col-4 mt-1 mb-1">
      <doc-list @update="setStockMovement" @close="showDocuments=false" :key="refreshDocList" v-bind:supplierId="order.supplierId"></doc-list>
    </div>

    <div v-else>

       <button v-if="btnBack" @click="$emit('step')" class="btn btn-secondary btn-block_ mr-2">      
              <i style="color:yellow" class="fas fa-reply mr-2" aria-hidden="true"></i>
              RITORNA ALLA LISTA PRODOTTI
      </button>

      <button @click="showDocumentsList" type="button"  class="btn btn-info   ml-1 mt-1 mb-1">
        <i style="color:black" class="fas fa-binoculars mr-2" aria-hidden="true"></i>
        LISTA DOCUMENTI DI ACQUISTO  
      </button> 

      <button @click="setNewDocument()" type="button"  class="btn btn-success   ml-1 mt-1 mb-1">
        <i style="color:black" class="fas fa-edit mr-2" aria-hidden="true"></i>
        NUOVO DOCUMENTO DI ACQUISTO 
      </button> 

     


</div>


<div v-if="false">
<button v-if="items.length==variants.length " @click="getFiltered()" type="button"  class="btn btn-info btn-sm float-right mb-2 mr-3">
    <i style="color:black" class="fas fa-filter mr-2" aria-hidden="true"></i>
    MOSTRA SOLO RIGHE DA CONSEGNARE 
</button> 

<button v-else @click="getFiltered()" type="button"  class="btn btn-info btn-sm float-right mb-2 mr-3">
    <i style="color:black" class="fas fa-eye mr-2" aria-hidden="true"></i>
    MOSTRA TUTTE LE RIGHE 
</button> 
</div>



<!-- TABLE -->
<div class="dataTable">              
  <div class="table-responsive-sm">  
      <table class="table table-bordered table-hover  table-sm mb-0 mt-4 my-table">
         
        <thead class="thead-light">
          
           <tr >
            
            <th class="text-center" :colspan="sizes.length+3" style="background_:#f8f9fa; font-weight:bold;">               
                  <delivery-document :key="refresh" v-if="stockMovementId" v-bind:stockMovementId="stockMovementId"></delivery-document>
            </th>            
            
          </tr>


          <tr class="header-measures">
            
            <th class="text-center" :colspan="sizes.length+3" style="background_:#f8f9fa; font-weight:bold;">
                    <product-info :productId="productId"></product-info>

            </th>            
            
          </tr>
          
          <tr class="header-measures">
            <th></th><th></th>                                  
            <th class="text-center" :colspan="sizes.length" style="background_:#f8f9fa; font-weight:bold;">MISURE</th>            
            <th  class="text-right"></th>
          </tr>


          <tr>           
               
                <th  class="sticky-desc">COLORE</th>
                <th  class="sticky-desc">COLORE FORNITORE</th>
                
                <!--<th  class="sticky-desc"></th>-->

                 <th v-for="(size, sIndex) in sizes" :key="'head-' + sIndex" class="text-center sticky-col" :style="{ width:  'auto_' }">
              {{ size.size }}
             
            </th>
        <th  class="text-right sticky-desc">TOTALE</th>
        </tr>

        </thead>


        <tbody>
          <tr
            v-for="(variant, vIndex) in variants"
            :key="'color-' + variant.colorId"
            :class="{ 'row-zero': isRowAllZero(variant) , 'row-focused': focusedRow === vIndex }"
          >

          
            <!-- Colore -->
            <td class="sticky-col sticky-color">
            
              <div  class="input-group input-group-sm align-items-stretch">

                <strong>{{ variant.colore }}</strong>

              </div>
                 <div class="form-check "> 
                  <input  :ref="'vSelect-' + vIndex" class="form-check-input" type="checkbox" :id="'defaultCheck'+ vIndex" v-model="variant.vSelect">
                    <label style="color:black" class="form-check-label text-nowrap" :for="'defaultCheck' + vIndex">
                      Non consegnare
                    </label>
                </div>
            </td>
            <!-- Supplier color -->
            <td class="sticky-col ">
              <div class="input-group input-group-sm align-items-stretch">
                <input
                  :ref="'supplierColor-' + vIndex"
                  
                  type="text"
                  class="form-control form-control-sm"
                  v-model="variant.supplierColor"
                  placeholder="Inserisci colore fornitore"
                />

                
              </div>
            </td>

            <td v-if="false">
                <div class="d-flex flex-column">                
                <label class="mt-2" >
                  ORDINATO/GIA' CONSEGNATO/IN CONSEGNA
                </label>
                <label v-if="false" >
                  IN CONSEGNA
                </label>
  
                </div>
            </td>


            

            <!-- Quantità per taglia -->
            <td
              v-for="(size, sIndex) in sizes"
              :key="size.sizeId+vIndex"
              class="text-center"
              :class="{ 'qty-zoomed': activeRow === vIndex }"
              
            >
              
               

                  <div  class="d-flex justify-content-between mb-1">

                    <!-- Badge sinistro -->
                    <div v-if="1== 0 && variant.quantities[0][size.sizeId]" class="badge-rect bg-light text-dark border badge-text-green">
                      {{ variant.quantities[0][size.sizeId] }}
                    </div>

                    <!-- Badge destro -->
                    <div v-if="1== 0 && variant.quantities[1][size.sizeId] > 0  && variant.quantities[1][size.sizeId] < variant.quantities[0][size.sizeId]" class="badge-rect bg-light text-dark border badge-text-blue">
                      {{ variant.quantities[1][size.sizeId] }}
                    </div>



                  


                      <!-- QUANTITÀ IN CONSEGNA -->
                      <div v-if="variant.quantities[0][size.sizeId]"  class="input-group input-group-sm  mb-2">
                          <div class="input-group-prepend">
                            <div class="input-group-text ordinato mr-1">
                               {{ variant.quantities[0][size.sizeId] }}
                            </div>
                             <div class="input-group-text consegnato mr-1">
                               {{ variant.quantities[1][size.sizeId] }}
                            </div>
                      </div>

                      <input

                        v-if="variant.quantities[0][size.sizeId]"
                        required
                        :min="0"
                        :max="1000"
                        type="number"
                        class="form-control form-control-sm text-center input-full mt-0 delivered-input"
                    
                        v-model.number="variant.quantities[2][size.sizeId]"
                        :ref="'qty-on_delivered-' + vIndex + '-' + sIndex"
                        title="Quantità in consegna"

                        @focus="activeRow = vIndex,focusedType = 'delivered',focusedRow = vIndex"
                        @blur="activeRow = null,focusedType = null,focusedRow = null"

                      />
                      </div>
                </div>
            </td>


            <td class="text-center"> 
              <div class="d-flex justify-content-between mb-1"> 
                <div v-if="getTotaleRiga(variant.quantities[0]) != getTotaleRiga(variant.quantities[1])"  class="badge-rect bg-light text-dark border badge-text-green">
                      {{ getTotaleRiga(variant.quantities[0]) }}
                </div>
                <div v-if="getTotaleRiga(variant.quantities[0]) != getTotaleRiga(variant.quantities[1])" class="badge-rect bg-info text-white border badge-text-green">
                      {{ getTotaleRiga(variant.quantities[1]) }}
                </div>
                <div v-if="getTotaleRiga(variant.quantities[0]) != getTotaleRiga(variant.quantities[1])" class="badge-rect bg-warning text-dark border badge-text-green">
                      {{ getTotaleRiga(variant.quantities[2]) }}
                </div>
                
                <!-- Totale consegnate --> 
                
                
              </div> 
            </td>



          </tr>
      </tbody>


       
        <tfoot class="thead-light">
          
          <tr class="font-weight-bold">
            
            <td class="align-middle">
            </td>
            <td></td>
            <td v-if="false"></td>

            <td  v-for="(size, sIndex) in sizes" :key="'foot-' + sIndex" class="text-center sticky-col" :style="{ width:  'auto' }">
              {{ size.size }}              
            </td>
            
            <td class="text-center total">
              <div class="d-flex justify-content-between w-100">
              
              <!-- Badge sinistro: ordinato -->
              <div  class="badge-rect bg-light text-dark border badge-text-green">
                  <strong>{{ totaliGenerali.ordinato }}</strong>
              </div>

              <!-- Badge destro: consegnato -->
              <div class="badge-rect bg-info text-white border badge-text-green">
                <strong>{{ totaliGenerali.consegnato }}</strong>
              </div>

              <!-- Badge destro: consegnato -->
              <div class="badge-rect bg-warning text-dark border badge-text-green">
                <strong>{{ totalIndelivery }}</strong>
              </div>


              </div>
            </td>

          </tr>
        </tfoot>        
      </table>

  </div>


<!-- Table -->
 </div>
  

  <button  @click="submit()" class="btn btn-primary  float-right mr-4 mt-2">
     <i style="color:yellow" class="fas fa-arrow-circle-right mr-2" aria-hidden="true"></i>
    PROCEDI
   
  </button>
 

</div>
<div v-else>
  
  <!-- DOCUMENTO DI CONSEGNA -->
  <document-form   v-bind:order="order" @update="setStockMovement" @close="delivery=true"></document-form>

</div>


   <div v-if="false">
      <h5 class="mb-4">Dati JSON:</h5>
      <pre> {{ sizes }} {{ prices }}</pre> 
      
    </div>

</div> 
</template>

<script>

import api                         from '@/api'
import productInfo                 from '@/components/product/ProductInfo.vue';

import documentForm                from '@/components/order/DocumentForm.vue';
import deliveryDocument            from '@/components/order/DeliveryDocument.vue';
import docList                     from '@/components/order/SupplierDocumentsInProgress.vue';


import modalMessage                from '@/components/modalDialog/ModalMessage.vue'         
import modalConfirm                from '@/components/modalDialog/ModalConfirm.vue'

import { mapGetters }  from 'vuex';
import { v4 as uuidv4 }      from 'uuid'

export default {

   components: {productInfo,docList,modalConfirm,modalMessage,documentForm,deliveryDocument},
  props : ['order','productId','_stockMovementId'],
  data () {
    return {      

      selected              : true,
      variants              : [],
      sizes                 : [],
      prices                : {},
      items                 : [],

      focusedType           : null, // "ordered" o "delivered"
      focusedRow            : null,
      activeRow             : null,

      delivery              : true,
      
      refreshDocList        : 100 ,
      refreshDoc            : 200,   
      showDocuments         : false,    
      
   
      discounts             : [],
      uuid                  : '',
      stockMovementId       : 0,
      refresh               : 300,
      flagVariazioneListino : [],
      vat                   : 0,
      btnBack               : true
             
      
    }
  },

 
  computed: 
  {   
    
   ...mapGetters(['company']),
  
   

  totaliGenerali() 
    { 
    let totaleOrdinato = 0; let totaleConsegnato = 0; 
    this.variants.forEach(item => { 
        const ordinato        = item.quantities[0]; 
        const consegnato      = item.quantities[1]; 
        const sommaOrdinato   = Object.values(ordinato).reduce((a, b) => a + Number(b), 0); 
        const sommaConsegnato = Object.values(consegnato).reduce((a, b) => a + Number(b), 0); 
        totaleOrdinato   += sommaOrdinato; 
        totaleConsegnato += sommaConsegnato; 
  }); 
    return { ordinato: totaleOrdinato, consegnato: totaleConsegnato }; 
  },

  totalIndelivery()
  {
      let totaleIndelivery = 0
      this.variants.forEach(item => { 
        if(item.vSelect == false)
        {
        const inDelivery = item.quantities[2];
        const sommaIndelivery = Object.values(inDelivery).reduce((a, b) => a + Number(b), 0); 
        totaleIndelivery += sommaIndelivery
        }
      })
    return totaleIndelivery
  }
   
  },
  mounted()
  {
    this.stockMovementId = this._stockMovementId
    this.refresh++
    this.getData()
  },
  created()
  { 
    
    
  
    this.uuid = uuidv4()
  },
 
  methods: 
  { 
  
  setNewDocument()
  {
    this.delivery = false
  },    
  setStockMovement(Id)  
  {
    this.delivery        = true
    this.stockMovementId = Id    
    this.showDocuments   = false
    this.refresh++

    // AGGIORNO COMPONENTE PADRE
    this.$emit('setStockMovement',Id)
    
    //this.delivery = true

  },
  getFiltered()
  {
    
    if(this.items.length == this.variants.length)
    {          
      const data = this.variants
      const filtered = data.filter(({ quantities }) =>
          Object.keys(quantities[0] || {}).some(
          key => (quantities[0][key] || 0) !== (quantities[1][key] || 0)
          )
      );
      this.variants = filtered
    }
    else
    {
      this.variants = this.items
    }

  },  

  getTableBase(variants, pricesData) {
        
        const prices = pricesData.prices;  
        const items  = [];

        variants.forEach(item => {
          
          const colorId        = item.colorId;
          const supplierColor  = item.supplierColor;
          const quantities     = item.quantities;
          const barcodes       = item.barcodes;
          
          Object.keys(barcodes).forEach(sizeId => 
          {

            const key                = String(sizeId)
            const InDelivery_qty     = Number(quantities[2][key]) 
            
            if(Number(InDelivery_qty) > 0  && item.vSelect == false)
            {
              items.push({

                barcode          : barcodes[key],                
                colorId          : colorId,
                supplierColor    : supplierColor,                
                InDelivery_qty   : InDelivery_qty,
                sizeId           : sizeId,
                costPrice        : prices[key].cost_price,
                retailPrice      : prices[key].price,
                vat              : this.vat

              })
            }
          })
        })

      return items
    },


    getTotaleRiga(variant)
    {
      const total = Object.values(variant).reduce((a,b)=>a + (b || 0), 0)
      return total 
    },
      isRowAllZero(variant) {
      /*  
      const quantities = variant.quantities;
      return Object.values(quantities).every(q => Number(q) === 0);
      */
        return true
    },  
  showDocumentsList()
  {
    this.refreshDocList++
    this.showDocuments = true
  },




  async submit()
  {
    
    if(this.totalIndelivery == 0)
    {

        // msg = "<i class='fas fa-exclamation-triangle mr-2' style='font-size:20px;color:red'></i>"
        const msg = 'QUANTITA\' CONSEGNATA NON INSERITA.'
        await this.$refs.msgModal.show(msg)        
        return
    }

    if(this.stockMovementId == 0)
    {
      await this.$refs.msgModal.show('INSERIRE IL DOCUMENTO DI ACQUISTO.',{},1)
      return
    }

    const items       = this.getTableBase(this.variants,this.prices)
    const sp          = 'spCreateWareHouseFromOrderDeliveringRequestLog'
    const payload     = {

                companyId         : this.company.Id,
                stockMovementId   : this.stockMovementId,
                productId         : this.productId,
                storeId           : this.order.storeId,
                orderId           : this.order.orderId,
                body              : items,
                discountList      : this.discounts,
                uuid              : this.uuid,
                sp
    }

  
     const confirmed=  await this.$refs.confirmModal.show(
          'REGISTRARE LA CONSEGNA ?',
          { title: 'CONFERMA REGISTRAZIONE' },1
        )

        if (!confirmed) return  
        this.$refs.confirmModal.close()
              
        this.saveData(payload)
        
  
  },
  
  async saveData(payload)
  { 
      this.btnBack = false
      this.$refs.confirmModal.close()
      this.$refs.msgModal.show('',{'spinner' : true,'title':'ELABORAZIONE IN CORSO ...'},5)      
      
      try{

       const res = await api.post(payload)
        
          if (res.status !== 200) 
          {
              throw new Error(res.data ||  res)
          }

            /*
            const recordsets = res.data.recordsets
            if (recordsets.length == 1) 
            {
              const result = recordsets[0][0]      
              if (result.status !== 'COMPLETED') 
              {
                throw new Error('OPERAZIONE NON ESEGUITA,RIPROVARE.')
              }
                    
            }
            */
            
            
            this.$emit('setStockMovement',this.stockMovementId)          
            this.$emit('update')          
    }
    catch(err){

                        
            let msg = err.message
            msg += '\nRIPROVARE.'
            this.$refs.msgModal.show(msg,{},3)
    }
 
  },
  
    async getData()
    {
        this.$refs.msgModal.show('',{'spinner' : true,'title':'ELABORAZIONE IN CORSO ...'})            
        const sp        = 'spOrderDetailProductQtyDeliveryInProgress'
        const payload   = {'orderId' : this.order.orderId, 'productId' : this.productId,sp}
        
      try{

         const res = await api.post(payload)
         if (res.status !== 200) 
          {
              throw new Error(res.data ||  res)
          }
          
              this.$refs.msgModal.close()            
          
              this.variants              = res.data.recordsets[0][0]
              this.sizes                 = res.data.recordsets[1][0]
              this.items                 = res.data.recordsets[0][0]
              this.prices                = res.data.recordsets[2][0]
              this.discounts             = res.data.recordsets[3]
              this.flagVariazioneListino = res.data.recordsets[4]
              this.vat                   = res.data.recordsets[5][0].vat

              
              
              if(this.flagVariazioneListino.length > 0)
              { 

                // let msg =  "<i class='fas fa-bell mr-2' style='font-size:20px;color:red'></i>"
                const msg = 'TI RICORDO DELLA VARIAZIONE LISTINO DI VENDITA.'
                await this.$refs.msgModal.show(msg,{},1)              
              }
          
          
        }catch(err)
        {
           this.$refs.msgModal.show(err.message)
        }
    



    }
  } 
}
</script>

<style scoped>
.form-check-label
    {
      cursor : pointer; 
    }

.form-check-input 
    {
      
      cursor : pointer; 
    }


.inputClass{

  font-weight       : bold;
  
   
  }

h4 {
  font-family: 'Roboto Condensed';
  font-size: 18px;
}


.dataTable_ {
position: relative;
height: 400px;
overflow: auto;
}


.table_ thead tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   :  white;
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }

 .badge-info
 {
  font-size : 20px;
 }

 .my-table,
.my-table th, 
.my-table td
{
  border-color: #28a745 !important;
}
thead th.sticky-col {
  z-index           : 20;
  background        : #73b682;;
  color             : black;
  border-color      : white !important;
  border-top        : 2px solid #28a745 !important; 
  border-bottom     : 2px solid #28a745 !important;
  
  padding-top       : 6px; /* distanza dal bordo superiore */ 
  padding-bottom    : 6px; /* distanza dal bordo inferiore */ 
  padding-left      : 8px; /* opzionale */ 
  padding-right     : 8px; /* opzionale */

}

tfoot{
  background-color: #e9ecef;;
}

/* footer */
tfoot td.sticky-col {
  z-index          :        20;
  color            : black;
  background       : #73b682;
  border-color     : white !important;
  border-top       : 2px solid #28a745 !important; 
  border-bottom    : 2px solid #28a745 !important;
}

input:disabled {
  background-color: white; /* colore che vuoi */
  color: #333;               /* testo visibile */
  border-color:white;        /* opzionale */
}

.badge-text-green {
  color        : #073a13;
  font-weight  : bold;
  border-color :rgb(4, 79, 9) !important;;        /* opzionale */
}

.badge-text-blue {
  color           : #6958c5;
  font-weight     : bold;
  border-color    :rgb(121, 85, 3) !important;;        /* opzionale */
}

.badge-rect {
  display: inline-block;
  padding: 0.35rem 0.65rem;
  border-radius: 0.25rem; /* arrotondato leggermente, 0 per angoli netti */
  min-width: 40px;
  text-align: center;
}
.sticky-desc{
  color            : black;
  background-color : rgb(228, 221, 213);
}

.input-full {
  /*
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 0;
  box-shadow: none;
*/
  font-weight       : bold;  
}


.ordinato{
  color : black;
  background-color: white;;
  border : 1px solid black;
}

.consegnato{

  color             : white;
  background-color  : #17a2b8;
  /*border            : 1px solid;*/
  border : 1px solid black;

}


.input-full:focus {
  outline      : none;
  border       : 3px solid #2846a7 !important;
  --box-shadow: 0 0 0 2px rgba(0,123,255,.25) !important;
}


.td-input:focus-within {
  box-shadow: inset 0 0 0 3px #28a745;
}


input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>